import { render, staticRenderFns } from "./LeftBlock.vue?vue&type=template&id=2dbc7c44&scoped=true&"
import script from "./LeftBlock.vue?vue&type=script&lang=ts&"
export * from "./LeftBlock.vue?vue&type=script&lang=ts&"
import style0 from "./LeftBlock.vue?vue&type=style&index=0&id=2dbc7c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc7c44",
  null
  
)

export default component.exports